import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';

import { Empresa } from '../../models/empresa'

@Injectable()
export class EmpresaLocalProvider {

  private _$empresa: BehaviorSubject<any>;

  constructor() {
    this._$empresa = new BehaviorSubject(this.getEmpresa());
  }

  public get $empresa() {
    return this._$empresa.asObservable();
}

  public setEmpresa(empresa: any[]): void {
    localStorage.setItem('grupos', JSON.stringify(empresa));
    this._$empresa.next(empresa[0]);
  }

  public getEmpresa(): any | undefined {
    const empresas = JSON.parse(localStorage.getItem('grupos'));
    if (!empresas) {
      return undefined;
    }
    if (Array.isArray(empresas)) {
      return empresas[0];
    }
    return empresas;
  }

  public getIdUsuario(): number {
    return this.getEmpresa().IdUsuario;
  }

  public getIdEmpresa(): number {
    return this.getEmpresa().IdEmpresa;
  }

}



// WEBPACK FOOTER //
// ./src/providers/empresa-local/empresa-local.ts